
import PageSearch from '../../../components/Search/PageSearch.vue';
import { PropType } from 'vue';
import { Category } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Category';
import { Sort } from 'modules/spravochnik/dt-front-page-generator/src/Entity/Sort/Sort';
import SortComponent from '../../../components/Sort/index.vue';

export default {
    components: {
        PageSearch,
        SortComponent,
    },
    props: {
        category: {
            type: Object as PropType<Category>,
            required: true,
        },
    },
    emits: ['openSorting','openSearch'],
    methods: {
        sortingFilter(value: Sort): void {
            this.sort = value;
        },
        onOpenSearch(): void {
            this.$emit('openSearch');
        },
    },
    data() {
        return {
            loading: false,
            sort: null,
        };
    },
};
